"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PipIcon = _interopRequireDefault(require("./PipIcon"));
var _default = (0, _styledComponents["default"])(_PipIcon["default"]).withConfig({
  displayName: "PackageDark",
  componentId: "sc-15ku3ga-0"
})(["background-position:-179px 0;&.responsive{@media (max-width:575.98px){background-position:-220px -45px;}}"]);
exports["default"] = _default;
//# sourceMappingURL=PackageDark.js.map